import React from 'react';
import { Link } from 'react-router-dom';

export default function PricingCard({ 
  title, 
  price, 
  description, 
  features, 
  buttonText, 
  buttonLink, 
  highlighted = false 
}) {
  return (
    <div className={`rounded-lg shadow-lg overflow-hidden ${
      highlighted ? 'border-2 border-primary-500 transform scale-105' : 'border border-gray-200'
    }`}>
      {highlighted && (
        <div className="bg-primary-500 text-white text-center py-2 font-medium">
          Beliebteste Wahl
        </div>
      )}
      <div className="px-6 py-8 bg-white sm:p-10 sm:pb-6">
        <div>
          <h3 className="inline-flex px-4 py-1 rounded-full text-sm font-semibold tracking-wide uppercase bg-primary-100 text-primary-800">
            {title}
          </h3>
        </div>
        <div className="mt-4 flex items-baseline text-6xl font-extrabold">
          €{price}
          <span className="ml-1 text-2xl font-medium text-gray-500">/monat</span>
        </div>
        <p className="mt-5 text-lg text-gray-500">{description}</p>
      </div>
      <div className="px-6 pt-6 pb-8 bg-gray-50 sm:p-10 sm:pt-6">
        <ul className="space-y-4">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start">
              <div className="flex-shrink-0">
                <svg className="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <p className="ml-3 text-base text-gray-700">{feature}</p>
            </li>
          ))}
        </ul>
        <div className="mt-8">
          <Link
            to={buttonLink}
            className={`block w-full rounded-md px-6 py-3 text-center font-medium text-white ${
              highlighted 
                ? 'bg-primary-600 hover:bg-primary-700' 
                : 'bg-primary-500 hover:bg-primary-600'
            }`}
          >
            {buttonText}
          </Link>
          {/* Stripe/Paypal Call-to-Action */}
          {price > 0 && (
            <button
              className="mt-4 w-full rounded-md px-6 py-3 text-center font-medium text-white bg-green-500 opacity-60 cursor-not-allowed"
              disabled
              title="Zahlungssystem folgt bald"
            >
              Jetzt upgraden mit Stripe/Paypal
            </button>
          )}
        </div>
      </div>
    </div>
  );
}